import { Injectable } from "@angular/core";

/**
 * Pack de observables
 */
import { Subject } from "rxjs/Subject";

// TECYMDV-1895 / dacordero@personalsoft.com.co / 2021-07-02 / Obligatoriedad de campos pantalla clientes por producto
@Injectable()
export class ClienteDireccionService {
  /**
   * Para la validación del formulario de RegistroClienteComponent en su padre ContenedorClienteComponent
   */

  private reporteErroresCliente = new Subject<boolean>();
  private reporteErroresProspecto = new Subject<boolean>();

  getReporteErroresCliente() {
    return this.reporteErroresCliente.asObservable();
  }
  getReporteErroresProspecto() {
    return this.reporteErroresProspecto.asObservable();
  }
  setReporteErroresCliente(hayErrores: boolean) {
    return this.reporteErroresCliente.next(hayErrores);
  }
  setReporteErroresProspecto(hayErrores: boolean) {
    return this.reporteErroresProspecto.next(hayErrores);
  }

  // -- Disparar la revalidación de todos los forms

  private revalidarTodosFormularios = new Subject<boolean>();

  getRevalidarTodosFormularios() {
    return this.revalidarTodosFormularios.asObservable();
  }

  setRevalidarTodosFormularios(revalidarTodosFormularios: boolean) {
    return this.revalidarTodosFormularios.next(revalidarTodosFormularios);
  }

  // -- Reporte de error de los formularios de DireccionClienteComponent para RegistroClienteComponent

  private reporteFormDireccion = new Subject<ReporteFormDireccion>();

  getReporteFormDireccion() {
    return this.reporteFormDireccion.asObservable();
  }

  setReporteFormDireccion(report: ReporteFormDireccion) {
    return this.reporteFormDireccion.next(report);
  }

  // ---------

  private limpiarTodasDirecciones = new Subject<boolean>();

  setLimpiarTodasDirecciones(limpia: boolean) {
    return this.limpiarTodasDirecciones.next(limpia);
  }

  getLimpiarTodasDirecciones() {
    return this.limpiarTodasDirecciones.asObservable();
  }

  // ---------

  private traspasoInfoDesdeProspectoACliente =
    new Subject<MensajeInterFormulario>();

  setTraspasoInfoDesdeProspectoACliente(msg: MensajeInterFormulario) {
    return this.traspasoInfoDesdeProspectoACliente.next(msg);
  }

  getTraspasoInfoDesdeProspectoACliente() {
    return this.traspasoInfoDesdeProspectoACliente.asObservable();
  }

  // ---------

  // Consumir para comparar valores entre campos de la vista de prospecto y la de cliente.
  private consultaEstadoCampoDiferente =
    new Subject<ConsultaEstadoCampoDiferente>();

  setConsultaEstadoCampoDiferente(msg: ConsultaEstadoCampoDiferente) {
    return this.consultaEstadoCampoDiferente.next(msg);
  }

  getConsultaEstadoCampoDiferente() {
    return this.consultaEstadoCampoDiferente.asObservable();
  }

  // ---------

  // Consumir para comparar valores entre campos de la vista de prospecto y la de cliente.
  private traspasarTodosCamposProspecto = new Subject<Boolean>();

  setTraspasarTodosCamposProspecto(debeTraspasarTodosCamposProspecto: boolean) {
    return this.traspasarTodosCamposProspecto.next(
      debeTraspasarTodosCamposProspecto
    );
  }

  getTraspasarTodosCamposProspecto() {
    return this.traspasarTodosCamposProspecto.asObservable();
  }
}

export class ReporteFormDireccion {
  constructor(
    public nombreForm: string,
    public invalido: boolean,
    public campo: string
  ) {}
}

export class MensajeInterFormulario {
  constructor(public nombreCampo: string, public valor: any) {}
}

export class ConsultaEstadoCampoDiferente {
  constructor(
    public nombreCampo: string,
    public valorActual: any,
    public accionSiIgual?: Function,
    public accionSiDiferente?: Function
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/services/cliente-direccion/cliente-direccion.service.ts